var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterundertaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8701 9.93262L10.0625 13.7471L8.22363 11.9014L8.83887 11.2861L10.0625 12.5029L13.2549 9.31738L13.8701 9.93262ZM7.875 4.375V0.875H1.75V13.125H7.875V14H0.875V0H8.49707L12.25 3.75293V8.75L11.375 9.625V4.375H7.875ZM8.75 3.5H10.7529L8.75 1.49707V3.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterundertaking);
export default __webpack_public_path__ + "static/media/letterundertaking.1d6b5369a4e2e1f76a71c77c3903b4f2.svg";
export { ForwardRef as ReactComponent };